import RichSnippets from './RichSnippets';

export default RichSnippets;
